/**
 * General Purpose Functions
 */

/**
 * Returns whether a given element is within the viewport
 * 
 * @param {DOM Object} $elem     DOM Object you want
 * 
 * @return {string}             visible, above, below if the element is in view, above view, or below view respectively
 */
function elementInView($elem) {
    let status = '';
    (function($) {
        let windowHeight = $(window).height();
        let bottomOfScreen = $(window).scrollTop() + windowHeight;
        let topOfScreen = $(window).scrollTop();

        let elemHeight = $elem.height();
        let elemTop = $elem.offset().top;
        let elemBottom = $elem.offset().top + elemHeight;
        status = 'below';
        if( bottomOfScreen > elemTop && topOfScreen < elemBottom ) {
            status = 'view';
        } else if( bottomOfScreen > elemTop && topOfScreen > elemBottom ) {
            status = 'above';
        }
    })(jQuery);
    return status;
}

/**
 * Scales and image to a given container
 * 
 * @param {DOM Object}  $container  Container object
 * @param {DOM Object}  $image      Image object
 * @param {boolean}     contain     True if image should be contained instead of cover
 * 
 */
function scaleImageContainer($container, $image, contain) {
    (function($) {
        let containerHeight = $container.height();
        let containerWidth  = $container.width();
        let imageWidth      = $image.get(0).naturalWidth;
        let imageHeight     = $image.get(0).naturalHeight;
        let newDimensions   = [];
        
        if( contain ) {
            newDimensions   = imgFitDimensions(imageWidth, imageHeight, containerWidth, containerHeight, 'contain');
        } else {
            newDimensions   = imgFitDimensions(imageWidth, imageHeight, containerWidth, containerHeight); 
        }        

        let scaleFactorX    = newDimensions.width / containerWidth;
        let scaleFactorY    = newDimensions.height / containerHeight;

        let imageStyle      = $image.attr('style');
        let scaleRegex      = /scale\([^)]+\)/;

        if( contain && newDimensions.width > containerWidth && newDimensions.height > containerHeight ) {
            scaleFactorX    = 1;
            scaleFactorY    = 1;
        }

        if( imageStyle ) {
            imageStyle  = imageStyle.replace(scaleRegex, `scale(${scaleFactorX}, ${scaleFactorY})`);
            $image.attr('style', imageStyle);
        } else {
            imageStyle  = `translateY(0) scale(${scaleFactorX}, ${scaleFactorY})`;
            $image.css('transform', imageStyle);
        }
    })(jQuery);
}

/**
 * Given the relation between where the screen is on the page,
 * image will get translated to create the sliding parallax effect.
 * 
 * Currently the image will slide by the max of either how much extra image there is 
 * available vertically after scaling or indicated slippage value (default 300).
 * 
 * This guarantees there will be no white space when the image is translated as well as,
 * not sliding so much that it is very unnatural.
 * 
 * I have not figured out a system yet to additionally scale the image for parallax if 
 * there's no imageOverflow vertically.
 * 
 * @param {DOM Object}  $container  General Container
 * @param {DOM Object}  $image      The image
 * @param {int}         slippage    Max amount in pixels that the image should translate.
 */
function parallaxImageContainer($container, $image, slippage) {
    (function($) {
        let windowHeight    = $(window).height();
        let bottomOfScreen  = $(window).scrollTop() + windowHeight;
        slippage            = slippage || 300;
        let imageHeight     = $image.get(0).naturalHeight;
    
        let containerHeight = $container.outerHeight();
        let containerTop    = $container.offset().top;
        let translateRegex  = /translateY\([^)]*\)/;
    
        let imageOverflow   = (imageHeight - containerHeight) / 2;
    
        let travelDistance = Math.min(imageOverflow, slippage); // max parallax distance
        let imageStyle = $image.attr('style');
        let newStyle = imageStyle;
    
        let bannerScrolled = bottomOfScreen - containerTop;
    
        if( imageStyle ) {
            let containerOutputHigh = travelDistance;
            let containerOutputLow = -1 * travelDistance;
            let inputHigh = containerHeight + windowHeight; // total amount a user scrolls
    
            // Scale between values
            // Result := ((Input - InputLow) / (InputHigh - InputLow)) * (OutputHigh - OutputLow) + OutputLow;
            let bannerTranslate = ( (bannerScrolled)  / (inputHigh) ) * (containerOutputHigh - containerOutputLow) + containerOutputLow; 
            newStyle = imageStyle.replace(translateRegex, `translateY(${bannerTranslate}px)`);
            $image.attr('style', newStyle); 
    
        } else {
            imageStyle  = `translateY(0) scale(1, 1)`
            $image.css('transform', imageStyle);
        }
    })(jQuery);
}

/**
 * Calculates the necessary dimensions given an image, container, and calculation type.
 * 
 * @param {int}     imgWidth 
 * @param {int}     imgHeight 
 * @param {int}     containerHeight 
 * @param {int}     containerWidth 
 * @param {string}  type            Options for type of image scaling, contain or cover  
 * 
 * @return {Object}                 Contains the new width and height dimensions. Returns false on bad objects
 */
function imgFitDimensions(imgWidth, imgHeight, containerWidth, containerHeight, type) {
    let imgRatio        = imgWidth / imgHeight;
    let containerRatio  = containerWidth / containerHeight;
    let test            = false;
    let returnObj       = {};

    switch(type) {
        case 'contain':
            test = (imgRatio > containerRatio); // for contain
            break;
        default:
            test = (imgRatio < containerRatio); // default cover
    }

    if( test ) {
        returnObj.width     = containerWidth;
        returnObj.height    = containerWidth / imgRatio;
    } else {
        returnObj.width     = containerHeight * imgRatio;
        returnObj.height    = containerHeight;
    }
    return returnObj;
}